import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { useSingleImageUrl } from '@blaze-cms/image-cdn-react';

const { SOCIAL_META_IMAGE_KEY, IMAGE_URL_KEY, IMAGE_CONTENT_URL_KEY } = require('../constants');

const LOAD_IN_HEAD = process.env.BLAZE_STRUCTURED_DATA_IN_HEAD === 'true';

const StructuredDataHeader = ({ structuredDataJsonLd, addNoArchiveHeader }) => {
  const [recordedStructuredDataJsonLd, ...otherStructuredDataJsonLd] =
    structuredDataJsonLd && structuredDataJsonLd['@graph'] ? structuredDataJsonLd['@graph'] : [];
  const image = recordedStructuredDataJsonLd ? recordedStructuredDataJsonLd.image || {} : {};
  const { [IMAGE_URL_KEY]: imageUrl, [IMAGE_CONTENT_URL_KEY]: contentUrl } = image;
  const convertedImageUrl = useSingleImageUrl({
    src: imageUrl,
    sizeKey: SOCIAL_META_IMAGE_KEY
  });
  const convertedContentUrl = useSingleImageUrl({
    src: contentUrl,
    sizeKey: SOCIAL_META_IMAGE_KEY
  });

  if (!recordedStructuredDataJsonLd) return null;

  const processedStructuredDataJsonLd = {
    ...recordedStructuredDataJsonLd
  };

  if (imageUrl) {
    processedStructuredDataJsonLd.image = {
      ...processedStructuredDataJsonLd.image,
      [IMAGE_URL_KEY]: convertedImageUrl
    };
  }

  if (convertedContentUrl) {
    processedStructuredDataJsonLd.image = {
      ...processedStructuredDataJsonLd.image,
      [IMAGE_CONTENT_URL_KEY]: convertedContentUrl
    };
  }

  const updatedStructuredDataJsonLd = {
    ...structuredDataJsonLd,
    '@graph': [processedStructuredDataJsonLd, ...otherStructuredDataJsonLd]
  };

  // script needs to be directly in head to render properly, cannot be nested in a component
  return (
    <>
      <Head>
        {LOAD_IN_HEAD && (
          <script
            key="structuredDataJsonLd"
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(updatedStructuredDataJsonLd) }}
          />
        )}
        {addNoArchiveHeader && <meta name="robots" content="noarchive" />}
      </Head>
      {!LOAD_IN_HEAD && (
        <script
          key="structuredDataJsonLd"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(updatedStructuredDataJsonLd) }}
        />
      )}
    </>
  );
};

StructuredDataHeader.propTypes = {
  addNoArchiveHeader: PropTypes.bool.isRequired,
  structuredDataJsonLd: PropTypes.object.isRequired
};

export default StructuredDataHeader;
